import ApiClient from "@/api/ApiClient";
import StorageHandler from "./StorageHandler";

class AuthenticatorHandler {
    constructor() {
        this.credentials = {
            email: process.env.VUE_APP_MASTER_USER_EMAIL ?? '',
            password: process.env.VUE_APP_MASTER_USER_PASS ?? ''
        }
        this.apiClient = null;
    }

    boot() {
        if (!this.apiClient) {
            this.apiClient = new ApiClient('api/auth/');
        }
    }

    async check() {
        this.boot();
        const checkResponse = await this.apiClient.executeRequest('currtoken', this.credentials, this.apiClient.methods.POST, {}, true);

        if(checkResponse.success()){
            StorageHandler.setEncryptedValue('tm_cervo_digital', checkResponse.getContent()?.token ?? '')
            return true;
        } else {
            const tokenResponse = await this.authenticate();
            if (tokenResponse.success()) {
                StorageHandler.setEncryptedValue('tm_cervo_digital', tokenResponse.getContent()?.token ?? '');
            }
        }
        return false;
    }

    async authenticate() {
        return await this.apiClient.executeRequest('authenticate', this.credentials, this.apiClient.methods.POST, {}, true);
    }
}

export default new AuthenticatorHandler(); 